import { ACCOUNT_BEFORE_UPSELL_COHORTS } from 'post-payment-config'

import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'
import { useUserAccountType } from 'hooks/useUserAccountType'

import { useCohortInfo } from './useCohortInfo'

export const usePostPaymentOrder = () => {
  const isLearnWorldsUser = useUserAccountType()
  const { cohortToUse } = useCohortInfo()
  const { isAyah110MonthlyUpsellTest } = useExperimentalFeatures()

  const isAccountBeforeUpsellOrder =
    (ACCOUNT_BEFORE_UPSELL_COHORTS.includes(cohortToUse) ||
      isAyah110MonthlyUpsellTest) &&
    !isLearnWorldsUser

  return {
    isAccountBeforeUpsellOrder,
  }
}
